<cmps-wait-status
    [srStatus]="'Loading ' + _config?.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="container-fluid"
    *ngIf="!hasPendingData && data != null"
>
    <div class="row">
        <div class="col-12 p-0">
            <ng-chart-vertical
                [options]="options"
                [data]="data.d3.data"
            ></ng-chart-vertical>
        </div>
    </div>
    <div
        class="row"
        *ngIf="_showGoToDashboardButton"
    >
        <div class="col-12 text-right mt-3 p-0">
            <button
                type="button"
                class="btn btn-primary"
                role="link"
                (click)="goToTeamDashboard()"
            >
                {{ i18n._746_DETAILS | translate }}
            </button>
        </div>
    </div>
</div>
